/**
 * Catalog (AI Onboarding) is built incrementally and lands in production
 * behind this flag. The catalog route and nav entry mount only when it is
 * the exact string "true", keeping partial code dormant in prod.
 */
export const isCatalogEnabled = (): boolean =>
  import.meta.env.VITE_CATALOG_ENABLED === "true";

/**
 * Switch for the brand catalog mount (BRAND_ADMIN self-serve). Declared as an
 * ARG/ENV in Dockerfile.web (2026-10-20, brand self-serve launch), so the web
 * service's Railway variable reaches the build. Unset there, the build reads
 * undefined and the brand mount stays closed.
 */
export const isCatalogBrandEnabled = (): boolean =>
  import.meta.env.VITE_CATALOG_BRAND_ENABLED === "true";

/** Bulk image upload panel. Also needs the API's S3 object store configured. */
export const isCatalogBulkImagesEnabled = (): boolean =>
  import.meta.env.VITE_CATALOG_BULK_IMAGES_ENABLED === "true";

/**
 * Admin Studio is off in production (Ari, 2026-10-12: "the studio is not
 * what I want live"). Dev builds show it. VITE_STUDIO_ENABLED is deliberately
 * NOT declared in Dockerfile.web, so a Railway variable alone cannot turn it
 * on; that takes a code change at the merge gate.
 */
export const isStudioEnabled = (): boolean =>
  import.meta.env.DEV || import.meta.env.VITE_STUDIO_ENABLED === "true";
